<template>
  <div>
    <div class="car-form-item car-form-item-hsn" :class="{'car-form-item-error': !validations.form.hsn.required && validations.form.hsn.$error || !validations.form.hsn.minLength && validations.form.hsn.$error}">
      <label for="hsn">{{$t('hsnTsnIdentification.hsn')}}*</label>
      <input type="text" id="hsn"
             :placeholder="$t('hsnTsnIdentification.hsn')+'*'"
             data-js="hsn-tsn__hsn--input"
             :class="{ 'car-filled': form.hsn }"
             v-model="form.hsn">
      <div class="car-error-message" v-if="!validations.form.hsn.required && validations.form.hsn.$error">
        {{$t('hsnTsnIdentification.errors.hsnRequired')}}
      </div>
      <div class="car-error-message" v-if="!validations.form.hsn.minLength && validations.form.hsn.$error">
        {{$t('hsnTsnIdentification.errors.hsnMinLength')}}
      </div>
    </div>
    <div class="car-form-item car-form-item-tsn" :class="{'car-form-item-error': !validations.form.tsn.required && validations.form.tsn.$error || !validations.form.tsn.minLength && validations.form.tsn.$error}">
      <label for="tsn">{{$t('hsnTsnIdentification.tsn')}}*</label>
      <input type="text" id="tsn"
             :placeholder="$t('hsnTsnIdentification.tsn')+'*'"
             :class="{ 'car-filled': form.tsn }"
             data-js="hsn-tsn__tsn--input"
             v-model="form.tsn">
      <div class="car-error-message" v-if="!validations.form.tsn.required && validations.form.tsn.$error">
        {{$t('hsnTsnIdentification.errors.tsnRequired')}}
      </div>
      <div class="car-error-message" v-if="!validations.form.tsn.minLength && validations.form.tsn.$error">
        {{$t('hsnTsnIdentification.errors.tsnMinLength')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HsnTsnForm',
  props: {
    form: {
      type: Object
    },
    validations: {
      type: Object
    }
  }
}
</script>
